import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import * as React from 'react';

interface IOption {
    text: string;
    value: string;
}
interface ISortBarOptions {
    options: IOption[];
    label: string;
    newSortString(props: { sortString: string }): void;
}

export class ShipSortBar extends React.Component<ISortBarOptions, {}> {
    render() {
        let onChangeDispatcher = (event) => {
            this.props.newSortString({ sortString: event.target.value });

            eventTracker.track({
                category: 'ship-overview',
                action: 'sort filter',
                label: event.target.value,
            });
        };

        return (
            this.props.options.length && (
                <div className="ship-overview-page--sortbar">
                    <div className="ship-overview-page--sortbar--label">{this.props.label}</div>
                    <div className="ship-overview-page--sortbar--dropdown">
                        <div className="ship-overview-page--sortbar--dropdown--arrow"></div>
                        <select onChange={onChangeDispatcher}>
                            {this.props.options.map((option) => {
                                return (
                                    <option value={option.value} key={option.value}>
                                        {option.text}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            )
        );
    }
}
